import { defineMessages } from 'react-intl';

export default defineMessages({
  backLabel: {
    id: 'Pdp.aovModal.backLabel',
    defaultMessage: 'Continue shopping',
  },
  warrantyPlan: {
    id: 'Pdp.aovModal.warrantyPlan',
    defaultMessage: 'Extend Protection Plan ({extendCount})',
  },
  addedToCart: {
    id: 'Pdp.aovModal.addedToCart',
    description: 'added to cart label',
    defaultMessage: 'Added to Cart',
  },
});
